import { render, staticRenderFns } from "./Izvestaji.vue?vue&type=template&id=b30e41da&"
import script from "./Izvestaji.vue?vue&type=script&lang=js&"
export * from "./Izvestaji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports